import React from 'react';
import Stack from 'atoms/Layout/Stack/Stack';
import MetricsGrid from 'molecules/MetricsGrid/MetricsGrid';

const HeroBannerMetricsItems = (): JSX.Element => {
  return (
    <Stack
      padding={['spacing-none', 'spacing-7xl']}
      paddingSm={['spacing-none', 'spacing-xl']}
    >
      <MetricsGrid
        totalColumns={4}
        totalColumnsLg={2}
        totalColumnsSm={2}
        items={[
          {
            metricNumber: '$500M',
            metricDescription: 'Host earnings this year',
          },
          {
            metricNumber: '$48',
            metricDescription: 'avg monthly price of memberships sold by our Hosts',
          },
          {
            metricNumber: '84%',
            metricDescription: 'member-led activity vs. 20% for other platforms',
          },
          {
            metricNumber: '60%',
            metricDescription: 'more member activity on native mobile apps vs. other platforms',
          },
        ]}
      />
    </Stack>
  );
};

export default HeroBannerMetricsItems;
